import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";

/** Shouts if this server cannot reach Google — the silent version of this cost days of guessing. */
export const MapsStatusBanner = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get("/places/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, []);

  if (!status || status.working) return null;

  return (
    <div data-testid="maps-status-banner"
      className="flex items-start gap-3 rounded-xl border border-red-500/40 bg-red-500/10 p-4">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-red-300" />
      <div>
        <p className="text-sm text-red-100">
          Address search and trip distance are not working on this server.
        </p>
        <p className="mt-1 text-xs text-red-200/80">{status.detail}</p>
        <p className="mt-2 text-xs text-slate-400">
          Until this is fixed, quotes will show the reservation fee with zero miles. Add
          <span className="mx-1 font-mono text-slate-200">GOOGLE_MAPS_API_KEY</span>
          to this environment's backend variables and redeploy.
        </p>
      </div>
    </div>
  );
};
